import styled from 'styled-components'

import { ClinTheme } from '../../../ClinTheme'

export const StyledProductDetailsSection = styled.div({
  backgroundColor: `${ClinTheme.colors.white}`,
  borderBottom: `1px solid ${ClinTheme.colors.grey}`,
  padding: `${ClinTheme.space[4]}px ${ClinTheme.space[3]}px`,
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxSizing: 'border-box'
})

export const StyledActions = styled.div({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  justifyContent: 'end'
})
